import React, { Suspense, lazy, useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { StoreProvider } from './Context/Context';
import './index.css'
import './index.scss'
import 'bootstrap/dist/css/bootstrap.min.css';
import LoadingPage from './pages/LoadingPage';
import Error404 from './Err/Error404';

const App = lazy(() => import('./pages/App'));
const Human = lazy(() => import('./pages/human'));
const PolicyTerms = lazy(() => import('./pages/Policy-Terms'));

const RootComponent = () => (
  <StoreProvider>
    <Suspense fallback={<LoadingPage />}>
      <Router>
        <Routes>
          <Route path="/" element={<App />} />
          <Route path="/policy-terms" element={<PolicyTerms />} />
          <Route path="/human" element={<Human />} />
          <Route path="/loading-tft" element={<LoadingPage />} />
          <Route path="/Get_ERR-404" element={<Error404 />} />
          <Route path="*" element={<Error404 />} />
        </Routes>
      </Router>
    </Suspense>
  </StoreProvider>
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RootComponent />
  </React.StrictMode>
);
